import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getCompanyGstinDataById = async (gstinId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/company-gstins/${gstinId}`);
        return await response.data;
    } catch (error) {
        console.log("getCompanyGstinById - error", error)
        return handleApiError(error)
    }
}

export const addCompanyGstinData = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-gstins/create`, data)
        return await response.data;
    } catch (error) {
        console.log("addCompanyGstin - error", error)
        return handleApiError(error)
    }
}

export const getGSTINByCompanyId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-gstins/`,data)
        return await response.data;
    }  catch (error) {
        console.log("getGSTINByCompanyId - error", error)
        return handleApiError(error)
    }
}

export const getCompanyGSTINs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-gstins/`, data);
        return await response.data;
    } catch (error) {
        console.log("getCompanyGSTINs - error", error)
        return handleApiError(error)
    }
}

export const verifyCompanyGSTINs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-gstins/bulk-update`, data);
        return await response.data;
    } catch (error) {
        console.log("verifyCompanyGSTINs - error", error)
        return handleApiError(error)
    }
}

export const updateCompanyGSTINsStatus = async(data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-gstins/gstin-status-update`, data)
        return await response.data
    } catch (error) {
        console.log("updateCompanyGSTINsStatus - error", error)
        return handleApiError(error)
    }
}